import styled from "styled-components";

const Header = styled.header`
  text-align: center;

  h2 {
    font-size: 24px;
    font-weight: bold;
    line-height: 30px;
    margin: 30px 0 12px 0;
  }

  p {
    font-weight: 400;
    line-height: 14px;
  }
`;

export { Header };
